import React from "react";
import { IonButton, IonImg, IonLabel, isPlatform } from "@ionic/react";
import "../../global.scss";

interface SocialIcons {
  imgpath: string;
  label: string;
  onClick: Function;
  isDisabled?: boolean;
}

export const SocialIcons: React.FC<SocialIcons> = (props: any) => {
  const  { imgpath, label, onClick, isDisabled }: SocialIcons = props;
  const HEIGHT = isPlatform("desktop") ? 50 : 60;
  const WIDTH = isPlatform("desktop") ? 50 : 60;
  return (
    <IonButton
      fill="clear"
      className="social-login-button"
      onClick={() => onClick()}
      style={{ height: HEIGHT }}
      disabled={isDisabled || false}
    >
      <img
        src={imgpath}
        style={{
          height: HEIGHT,
          width: WIDTH,
          maxWidth: "none",
        }}
      />
      <IonLabel className="login31">{label}</IonLabel>
    </IonButton>
  );
};
